// extracted by mini-css-extract-plugin
export var active = "search-module--active--e384e";
export var author = "search-module--author--cc213";
export var category = "search-module--category--755ce";
export var headline = "search-module--headline--31999";
export var headlinePost = "search-module--headline-post--1423b";
export var paragraph = "search-module--paragraph--b7211";
export var sidebar = "search-module--sidebar--99ada";
export var tagList = "search-module--tag-list--05a2a";